<template>
    <li>
        <div class="item-thumb">
            <a :target="target" :href="post.link">
                <img
                    width="250"
                    :src="post.thumbnail"
                    class="attachment-bpi-thumb size-bpi-thumb"
                    alt=""
                >
            </a>
            <template v-if="post.type">
                <div class="type-colorful-thumb">
                    <a :target="target" :href="post.url">{{post.type}}</a>
                </div>
            </template>
        </div>
        <p class="item-title">
            <a :target="target" :href="post.link">{{ post.title }}</a>
        </p>
        <div class="item-footer">
            <div class="user-widget">
                <i class="fa fa-eye" /> <span class="viewCount">{{roundedViews}}</span>
            </div>
        </div>
    </li>
</template>

<script setup>
    import {computed} from 'vue';
    const props = defineProps({
        post: Object
    });

    const target = computed(() => {
        if (window.location.pathname.includes('/feed')) {
            return '_blank';
        } else {
            return '_self';
        }
    });

    // rounded view number
    const roundedViews = computed(() => {
        let count = props.post.views || 0;
        if(count >= 1000){
            if (count % 1000 !== 0){
                count = (count/1000).toFixed(1);
            } else {
                count = count/1000;
            }
            count= ` ${count}k`;
            return count;
        } else {
            return ` ${count}`;
        }
    });

</script>

<style lang="less" scoped>

</style>
